export enum DossierStateEnum {
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
  INIT = 'INIT',
  QUALIFIED = 'QUALIFIED',
  SLOT_SEARCH = 'SLOT_SEARCH',
  SLOT_SUGGESTED = 'SLOT_SUGGESTED',
  DONE = 'DONE',
  NO_SHOW = 'NO_SHOW',
  ABANDONED = 'ABANDONED',
}
export type DossierState = `${DossierStateEnum}`;

export interface DossierStateHistory {
  userId?: string;
  userType: UserType;
  userName?: string;
  timestamp: Date;
  state: DossierState;
  data?: any;
}

export enum UserTypeEnum {
  FITTER = 'FITTER',
  CUSTOMER = 'CUSTOMER',
  INSURER = 'INSURER',
  API = 'API',
}
export type UserType = `${UserTypeEnum}`;
